import { PatientMedsExpireDetails } from "../../../../services/medicationmanagement/patientApi/models/PatientMedsExpireDetails";
import { NonMandatory } from "../../../common";

export interface ResidentMedsState{
    data:{
        expiredMeds:NonMandatory<PatientMedsExpireDetails[]>;
        expiringMeds:NonMandatory<PatientMedsExpireDetails[]>;
    };
    progress:RowActionTypes;
}

export enum ResidentRowActions {
    Expand,
    Collapse,
    Toggle
}

export enum RowActionTypes {
    StartLoadingDetails = 'START-LOADING',
    DetailsLoaded = 'DETAILS-LOADED',
    DetailsLoadingFailed = 'DETAILS_LOADING_FAILED',
    ResetDetails = 'RESET-DETAILS',
    InitialiseDetails = 'INITIALISE-DETAILS'
}

function getResidentName(
    givenName: NonMandatory<string>,
    familyName: NonMandatory<string>,
    middleName: NonMandatory<string>,
    preferredName: NonMandatory<string>
  ) {
      if (!preferredName) {
          return `${familyName || ""}, ${givenName || ""} ${middleName || ""}`.trim();
      }
      return `${familyName || ""}, ${givenName || ""} ${middleName || ""
       } (${preferredName})`.trim();
  }

  const residentMedicationDetailsReducer = (state:ResidentMedsState,action:[RowActionTypes,any]):ResidentMedsState=>{
    let type = action[0];
    let payload = action[1];
    switch (type) {
        case RowActionTypes.StartLoadingDetails:
            return {
                ...state,
                progress:RowActionTypes.StartLoadingDetails
            };
        case RowActionTypes.DetailsLoaded:
            return {
                ...state,
                data: payload,
                progress:RowActionTypes.DetailsLoaded
            };
        case RowActionTypes.DetailsLoadingFailed:
            return {
                ...state,
                data:{
                    expiredMeds:[],
                    expiringMeds:[]
                },
                progress:RowActionTypes.DetailsLoadingFailed
            };
            case RowActionTypes.ResetDetails:
                return {
                    ...state,
                    data:{
                        expiredMeds:[],
                        expiringMeds:[]
                    },
                    progress:RowActionTypes.ResetDetails
                };
    }
    return state;
}

export {getResidentName, residentMedicationDetailsReducer}